import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { AuthenticationService } from '../../core/_services/authentication.service';
import { AlertasService } from '../../core/_services/alerta.service';
import { CoreService } from '../../core/_services/core.services';

@Component({
  selector: 'app-verificar-activacion',
  templateUrl: './app.verificar-activacion.component.html',
})
export class AppVerificarActivacionComponent implements OnInit {

  token: any;
  mensaje: any;
  titulo: any;

  constructor(
    private route: ActivatedRoute,
    private service: AuthenticationService,
    public msj: AlertasService,
    public coreService: CoreService,
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    console.log(this.token);
    this.coreService.get('/verificar-cuenta?token=' + this.token).subscribe(
      (res: any) => {
        this.mensaje = res;


      },
      (err: any) => {
        console.log(err);
      }
    )
  }

}
